var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from "react";
import JSZip from "jszip";
import messages from "../messages.i18n";
import { useIntl } from "react-intl";
import { DownloadCloud } from "@piiqtechnologies/svg-icons";
import { fetchImageAsBlob, useError, getFileExtension, downloadFileFromUrl, useAnalytics, } from "@piiqtechnologies/ui-lib";
import { SpaceActionButton } from "@components/space-actions";
import { CircularProgressWithLabel } from "@piiqtechnologies/ui-components";
export const SpaceDownload360PhotoAction = ({ space }) => {
    const intl = useIntl();
    const { setError } = useError();
    const [loader, setLoader] = useState(false);
    const [progress, setProgress] = useState(0);
    const analytics = useAnalytics();
    const updateProgress = (current, total) => {
        const percentage = Math.round((current / total) * 100);
        setProgress(percentage);
    };
    const onDownload360Photo = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const zip = new JSZip();
        setLoader(true);
        try {
            for (const node of space.nodes) {
                const { label, photo } = node;
                const { url } = photo;
                const blob = yield fetchImageAsBlob(url);
                zip.file(`${label}${getFileExtension(url)}`, blob);
                updateProgress(space.nodes.indexOf(node), space.nodes.length);
            }
            // Generate zip file
            const zipBlob = yield zip.generateAsync({ type: "blob" });
            const zipUrl = URL.createObjectURL(zipBlob);
            downloadFileFromUrl(zipUrl, `${space.unit}.zip`);
        }
        catch (error) {
            console.error("Error downloading 360° photo", error);
            setError(intl.formatMessage(messages.errorDownload360Photo));
        }
        finally {
            setLoader(false);
            setProgress(0);
            analytics.track("Download 360° Photos", {
                spaceId: space._id,
                spaceType: space.type,
                communityId: (_a = space.community) === null || _a === void 0 ? void 0 : _a._id,
                communityName: (_b = space.community) === null || _b === void 0 ? void 0 : _b.name,
            });
        }
    });
    if (loader) {
        return React.createElement(CircularProgressWithLabel, { value: progress, color: "secondary", size: 35 });
    }
    return (React.createElement(SpaceActionButton, { "aria-label": "Export 360\u00B0 Photos", Icon: DownloadCloud, iconSize: 14, tooltip: intl.formatMessage(messages.actionsDownload360Photo), onClick: onDownload360Photo }));
};
export default SpaceDownload360PhotoAction;
